import React, { useCallback } from 'react'
import { AsyncMultiPick, type AsyncMultiPickProps, type MultiPickOption } from '@duck/ui'
import { apis } from '@/modules/apiClients'

export type TaskDataInputProps = Omit<AsyncMultiPickProps, 'mode' | 'fetchOptions'>

/**
 * Shared task list -> options mapper, reused by both the generic data input
 * and table filters that need async/preloaded task selection.
 */
export const fetchTaskOptions = async (): Promise<MultiPickOption[]> => {
  const { data } = await apis.taskService.rootGet()

  return data.map((task) => ({
    value: task.id,
    label: task.name ?? task.id,
  }))
}

export const TaskDataInput: React.FC<TaskDataInputProps> = (props) => {
  const fetchOptions = useCallback(fetchTaskOptions, [])

  return (
    <AsyncMultiPick
      mode="preload"
      fetchOptions={fetchOptions}
      {...props}
    />
  )
}

